<template>
  <div class="card" :class="cardClass">
    <div class="card-header" v-if="showHeader">
      <div class="skeleton skeleton-title"></div>
    </div>
    <div class="card-body" :style="{ minHeight: height }">
      <div v-if="variant === 'stats'">
        <!-- Stats Skeleton -->
        <div class="d-flex justify-content-between align-items-center mb-3">
          <div class="flex-grow-1">
            <div class="skeleton skeleton-text" style="width: 60%;"></div>
            <div class="skeleton skeleton-title mt-2" style="width: 40%;"></div>
          </div>
          <div class="skeleton skeleton-avatar"></div>
        </div>
      </div>

      <div v-else-if="variant === 'list'">
        <!-- List Skeleton -->
        <div v-for="i in rows" :key="i" class="mb-3">
          <div class="d-flex align-items-start">
            <div class="skeleton skeleton-avatar me-3"></div>
            <div class="flex-grow-1">
              <div class="skeleton skeleton-text" style="width: 80%;"></div>
              <div class="skeleton skeleton-text mt-1" style="width: 60%;"></div>
            </div>
            <div class="skeleton skeleton-text" style="width: 60px;"></div>
          </div>
        </div>
      </div>

      <div v-else-if="variant === 'calendar'">
        <!-- Calendar Event Skeleton -->
        <div v-for="i in rows" :key="i" class="mb-3">
          <div class="d-flex align-items-center">
            <div class="skeleton" style="width: 60px; height: 60px; border-radius: 8px; margin-right: 1rem;"></div>
            <div class="flex-grow-1">
              <div class="skeleton skeleton-text" style="width: 40%;"></div>
              <div class="skeleton skeleton-text mt-1" style="width: 70%;"></div>
            </div>
          </div>
        </div>
      </div>

      <div v-else>
        <!-- Default Skeleton -->
        <div v-for="i in rows" :key="i" class="mb-2">
          <div class="skeleton skeleton-text" :style="{ width: getRandomWidth() }"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonCard',
  props: {
    variant: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'stats', 'list', 'calendar'].includes(value)
    },
    rows: {
      type: Number,
      default: 3
    },
    height: {
      type: String,
      default: 'auto'
    },
    showHeader: {
      type: Boolean,
      default: false
    },
    cardClass: {
      type: String,
      default: ''
    }
  },
  methods: {
    getRandomWidth() {
      const widths = ['100%', '90%', '80%', '70%', '85%'];
      return widths[Math.floor(Math.random() * widths.length)];
    }
  }
};
</script>

<style scoped>
/* Component-specific styles if needed */
</style>
